import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid2";
import { useFormik } from "formik";
import dayjs from "dayjs";
import ActionButton from "../../../Components/custom_components/CustomButtons/ActionButton/ActionButton";
import CustomBreadcrumbs from "../../../Components/custom_components/CustomBreadcrumbs/CustomBreadcrumbs";
import CustomSelectDropdown from "../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown";

const emptyFilters = {
    Survey_from_date: "",
    Survey_end_date: "",
    year: "",
    month: "",
};

function FseScheduleSearch({ tableTitle, searchFilter }) {
    const [filters, setFilters] = useState(emptyFilters);

    const formik = useFormik({
        initialValues: filters,
        onSubmit: (values) => {
            if (values.Survey_from_date && values.Survey_end_date) {
                searchFilter({
                    Survey_from_date: values.Survey_from_date,
                    Survey_end_date: values.Survey_end_date,
                });
            }
        },
    });

    // ✅ Auto-select current year & month on load
    useEffect(() => {
        const currentYear = dayjs().year();
        const currentMonth = dayjs().format("MM");
        const startDate = dayjs(`${currentYear}-${currentMonth}-01`);
        const endDate = startDate.endOf("month");

        const formattedStart = startDate.format("DD-MM-YYYY");
        const formattedEnd = endDate.format("DD-MM-YYYY");

        const defaultValues = {
            year: currentYear,
            month: currentMonth,
            Survey_from_date: formattedStart,
            Survey_end_date: formattedEnd,
        };

        formik.setValues(defaultValues);
        setFilters(defaultValues);
        searchFilter(defaultValues);
    }, []);

    const handleYearMonthChange = (name, value) => {
        formik.setFieldValue(name, value);
        const selectedYear = name === "year" ? value : formik.values.year;
        const selectedMonth = name === "month" ? value : formik.values.month;

        if (selectedYear && selectedMonth) {
            const startDate = dayjs(`${selectedYear}-${selectedMonth}-01`);
            const endDate = startDate.endOf("month");

            const formattedStart = startDate.format("DD-MM-YYYY");
            const formattedEnd = endDate.format("DD-MM-YYYY");

            formik.setFieldValue("Survey_from_date", formattedStart);
            formik.setFieldValue("Survey_end_date", formattedEnd);

            searchFilter({
                Survey_from_date: formattedStart,
                Survey_end_date: formattedEnd,
            });
        }
    };

    const handleReset = () => {
        const currentYear = dayjs().year();
        const currentMonth = dayjs().format("MM");
        const startDate = dayjs(`${currentYear}-${currentMonth}-01`);
        const endDate = startDate.endOf("month");

        const formattedStart = startDate.format("DD-MM-YYYY");
        const formattedEnd = endDate.format("DD-MM-YYYY");

        const resetValues = {
            year: currentYear,
            month: currentMonth,
            Survey_from_date: formattedStart,
            Survey_end_date: formattedEnd,
        };

        formik.setValues(resetValues);
        setFilters(resetValues);
        searchFilter(resetValues);
    };
    const currentYear = dayjs().year();
    const breadcrumbs = ["Schedule", tableTitle];
    const years = Array.from({ length: 9 }, (_, i) => currentYear + i); // 5 years back + 3 ahead
    const months = Array.from({ length: 12 }, (_, i) => dayjs().month(i).format("MM"));
    const selectedYear = formik.values.year || dayjs().year();
    const selectedMonth = formik.values.month || dayjs().format("MM");

    return (
        <div className="schedule-search-filter-container">
            <div className="schedule-search-filter-sub-container">
                <div className="schedule-search-filter-header">
                    <div className="schedule-search-filter-left">
                        <div className="schedule-table-title">{tableTitle}</div>
                        <CustomBreadcrumbs breadcrumbs={breadcrumbs} />
                    </div>
                </div>

                <div className="search-layout-wrapper">
                    <div className="search-filter-container">
                        <div className="search-inputs-fields">
                            {/* Year Dropdown */}
                            <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="year"
                                    placeholder="Select Year"
                                    options={years.map((yr) => ({ label: yr, value: yr }))}
                                    value={{ label: selectedYear, value: selectedYear }}
                                    onChange={(selectedOption) =>
                                        handleYearMonthChange("year", selectedOption?.value)
                                    }
                                    isMulti={false}
                                    isClearable={false}
                                    width="200px"
                                />
                            </Grid>

                            {/* Month Dropdown */}
                            <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="month"
                                    placeholder="Select Month"
                                    options={months.map((mn) => ({
                                        label: dayjs(`${selectedYear}-${mn}-01`).format("MMMM"),
                                        value: mn,
                                    }))}
                                    value={{
                                        label: dayjs(`${selectedYear}-${selectedMonth}-01`).format("MMMM"),
                                        value: selectedMonth,
                                    }}
                                    onChange={(selectedOption) =>
                                        handleYearMonthChange("month", selectedOption?.value)
                                    }
                                    isMulti={false}
                                    isClearable={false}
                                    width="200px"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <ActionButton onClick={handleReset} label="Reset" btnType="outlined" />
                            </Grid>
                        </div>

                        <div className="search-buttons-fixed-right">
                            {/* <ActionButton
                onClick={formik.handleSubmit}
                label="Search"
                btnType="primary"
              /> */}
                            {/* <ActionButton onClick={handleReset} label="Reset" btnType="outlined" /> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FseScheduleSearch;
